import styled from 'styled-components';

export const SpacerContainer = styled.div`
    ${props => props.BackgroundColor && `background-color: var(--${props.BackgroundColor});`}

    height: ${props => props.Size ? `var(--spacer-size-${props.Size.toLowerCase()})` : 'auto'};
`;